export const apiPath = '/v1/cards';
const actionType = 'ACTION_REQUEST';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
